// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"300":"c05f59a8e1c60655","521":"c4f120c0da4ebe1f"}[chunkId] + ".js";
};